import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faTimesCircle, faArrowLeft, faCreditCard, faQuestionCircle 
} from '@fortawesome/free-solid-svg-icons'

export default function CoordinatorUpgradeCancel() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="app-header">
        <div className="flex items-center justify-between max-w-md mx-auto">
          <Link to="/dashboard" className="app-header-back">
            <FontAwesomeIcon icon={faArrowLeft} className="h-6 w-6" />
          </Link>
          <h1 className="app-header-title">Payment Cancelled</h1>
          <div className="w-6"></div>
        </div>
      </header>

      {/* Cancel Content */}
      <main className="p-4 max-w-md mx-auto">
        <div className="bg-white rounded-lg p-8 text-center">
          {/* Cancel Icon */}
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FontAwesomeIcon icon={faTimesCircle} className="h-12 w-12 text-red-600" />
          </div>

          {/* Cancel Message */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Payment Cancelled
          </h2>
          <p className="text-gray-600 mb-6">
            Your coordinator upgrade payment was cancelled. No charges have been made to your account.
          </p>

          {/* Information */}
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-orange-800 mb-2">What You Missed</h3>
            <ul className="text-sm text-orange-700 space-y-2 text-left">
              <li className="flex items-center">
                <span className="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></span>
                <span>Ability to create and manage mountain biking events</span>
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></span>
                <span>Access to participant management tools</span>
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></span>
                <span>Professional coordinator status and badge</span>
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></span>
                <span>1 event creation credit (worth R300)</span>
              </li>
            </ul>
          </div>

          {/* Pricing Reminder */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-gray-800 mb-2">Coordinator Upgrade</h3>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">One-time upgrade cost:</span>
              <span className="font-bold text-lg text-gray-900">R300</span>
            </div>
            <p className="text-sm text-gray-600 mt-2">
              Includes coordinator status + 1 event creation credit
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Link
              to="/dashboard"
              className="block w-full bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors font-medium flex items-center justify-center space-x-2"
            >
              <FontAwesomeIcon icon={faCreditCard} className="h-5 w-5" />
              <span>Try Payment Again</span>
            </Link>
            <Link
              to="/dashboard"
              className="block w-full border border-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Return to Dashboard
            </Link>
            <Link
              to="/events"
              className="block w-full text-orange-600 px-6 py-3 rounded-lg hover:bg-orange-50 transition-colors text-sm"
            >
              Browse Events Instead
            </Link>
          </div>

          {/* Help Section */}
          <div className="mt-6 text-xs text-gray-500 bg-gray-50 p-3 rounded-lg">
            <div className="flex items-center justify-center mb-2">
              <FontAwesomeIcon icon={faQuestionCircle} className="h-4 w-4 mr-1" />
              <span className="font-semibold">Need Help?</span>
            </div>
            <p>If you're experiencing payment issues or have questions about becoming a coordinator, please contact our support team.</p>
            <Link
              to="/contact"
              className="text-orange-600 hover:text-orange-700 font-medium mt-2 inline-block"
            >
              Contact Support
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
} 